module.exports = {
    formatStroop: function (value) {
        try {
            return Math.round((value) * 10000000) / 10000000
        } catch (e) {
            return e
        }
    }
}